module.exports = __webpack_public_path__ + "img/لوکس.c9ad272b.png";